"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _form = _interopRequireDefault(require("./form"));
var CustomIcon = function CustomIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.315 4.902a9.807 9.807 0 0 0-.96 1.045l5.258 5.257 1.59-1.591-4.666-4.666c-.336-.337-.876-.371-1.222-.045zm13.369 14.196c.345-.325.665-.674.96-1.045L14.38 12.79l-1.591 1.59 4.672 4.673c.336.337.876.371 1.222.044z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.96 7.552 4.357 5.947A9.709 9.709 0 0 0 2.25 12c0 2.287.787 4.39 2.106 6.053l1.605-1.604A7.466 7.466 0 0 1 4.5 12c0-1.665.543-3.203 1.46-4.448zm12.075-.002 1.607-1.606a9.707 9.707 0 0 1 2.104 6.053 9.714 9.714 0 0 1-2.102 6.056l-1.609-1.607a7.466 7.466 0 0 0 1.461-4.449 7.466 7.466 0 0 0-1.46-4.448z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.643 5.947a9.802 9.802 0 0 0-.959-1.045c-.346-.326-.886-.292-1.222.045L4.355 18.053c.295.371.615.72.96 1.044.346.327.886.293 1.222-.044L19.644 5.947z"
  })));
};
CustomIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
var config = {
  angConfiguration: {
    typeURL: 'http://anypoint.com/vocabs/digital-repository#CustomAsset',
    assetType: 'Custom'
  },
  owner: {
    gusTeam: 'MS Exchange Catalog',
    gusTeamLink: 'https://gus.lightning.force.com/lightning/r/ADM_Scrum_Team__c/a00AH000000in0tYAA/view'
  },
  name: 'Custom',
  pluralName: 'Custom',
  publication: {
    uiForm: _form.default,
    inferredBy: [{
      classifiers: ['custom']
    }, {
      typeProperty: 'custom'
    }],
    files: [{
      id: 'custom',
      classifier: 'custom',
      packaging: '**'
    }],
    minimumInputSets: [{
      files: ['custom']
    }, {
      files: []
    }],
    extensionPoints: [{
      name: 'validation'
    }]
  },
  portal: {
    icon: CustomIcon,
    color: '#a1b1b8',
    // robustBlue1
    files: ['custom']
  }
};
var _default = exports.default = config;
//# sourceMappingURL=config.js.map